module.exports = __webpack_public_path__ + "static/media/food_2.5f73fb9f.png";